export class CrfVisitRequest {
    "patientId":String;
    "studyId":Number;
    "userId":Number;
}